import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';

class CmsLaundryDeliveryStore {
  @observable data = [];
  @observable laundryDeliveryOptions = [];
  @observable laundryDelivery = null;

  @action getData() {
    return apiCaller.CmsLaundryDeliveries.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getOptions() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsLaundryDeliveries.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        if (resp.length > 0) {
          let options = [];
          resp.map(item => {
            options.push({
              label: item.name,
              value: item.name
            });
            return item;
          });
  
          this.laundryDeliveryOptions = options;
          this.laundryDelivery = options[0].value;
        } else {
          this.laundryDeliveryOptions = [];
          this.laundryDelivery = null;
        }
      } else {
        this.laundryDeliveryOptions = [];
        this.laundryDelivery = null;
      }
    })
  }

  @action initCreate(activeLanguages) {
    const getDataByIdZero = this.data.find(fi => fi.id === 0);
    if (!getDataByIdZero) {
      let newData = {
        'id': 0,
        'sort': 0,
        'laundryDeliveryLanguages': []
      };

      activeLanguages.map(lang => {
        newData.laundryDeliveryLanguages.push({
          'id': 0,
          'laundryDeliveryId': 0,
          'languageId': lang.id,
          'name': ''
        });

        return lang;
      });

      this.data.push(newData);
    }
  }

  @action create() {
    const request = this.data.find(fi => fi.id === 0);
    return apiCaller.CmsLaundryDeliveries.create(request);
  }

  @action update(id) {
    const request = this.data.find(fi => fi.id === id);
    return apiCaller.CmsLaundryDeliveries.update(id, request);
  }

  @action delete(id) {
    return apiCaller.CmsLaundryDeliveries.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setsort(id, value) {
    let item = this.data.find(fi => fi.id === id);
    if (item) {
      item.sort = value;
    }
  }

  @action setname(id, langId, value) {
    let item = this.data.find(fi => fi.id === id);
    if (item) {
      let lang = item.laundryDeliveryLanguages.find(fi => fi.languageId === langId);
      if (lang) {
        lang.name = value;
      }
    }
  }

  @action setlaundryDelivery(value) {
    this.laundryDelivery = value;
  }

  @action resetData() {
    this.laundryDelivery = null;
    this.laundryDeliveryOptions = [];
  }
}

export default new CmsLaundryDeliveryStore();